<template>
    <div class="container-main">
        <div class="d-flex justify-space-between">
            <div class="container-main-header-button">
                <v-btn depressed @click="back">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <span>Редактирование</span>
            </div>
            <div>


            </div>
        </div>


        <div v-if="!newImage" class="container-block">
            <div class="container-block-title">
                Изображение
            </div>

            <v-file-input accept="image/*" outlined
                :rules="[value => (value && value.size < 104857600) || 'Размер изображения не больше 100 мб']"
                hint="Максимальный размер изображения 100 мб" persistent-hint v-model="newImage" @change="previewImage"
                label="Прикрепить изображение"></v-file-input>
            <div class="container-block-gallery-button">
                Выбрать изображение из галереи
            </div>

        </div>


        <div v-if="newImage" class="container-block" style="width: 100%">
            <div class="container-block-title">
                Кадрировать изображение
            </div>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">
                                Формат
                            </th>
                            <th class="text-left">
                                Место отображенния
                            </th>
                            <th class="text-left">
                                Для смартфонов
                            </th>
                            <th class="text-left">
                                Для планшетов
                            </th>
                            <th class="text-right">

                            </th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr style="height: 60px;" v-if="newImage">
                            <td class="text-left">Иконка раздела</td>
                            <td class="text-left">Изображение на фоне раздела</td>
                            <td class="text-left">
                                <v-btn v-if="!finishImageMobile" @click="openMobileImg(false)" class="button-accept"
                                    style="width: auto !important">
                                    Кадрировать
                                </v-btn>

                                <div v-else class="d-flex">
                                    <img @click="openMobileImg(false)" class="table-img" :src="finishImageMobile">
                                    <v-btn outlined @click="openMobileImg(false)" color="var(--app-dark-blue-1) "
                                        class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                                        Изменить
                                    </v-btn>
                                </div>

                            </td>
                            <td class="text-left">
                                <v-btn v-if="!finishImageTablet" @click="openTabletImg(false)" class="button-accept"
                                    style="width: auto !important">
                                    Кадрировать
                                </v-btn>
                                <div v-else class="d-flex">
                                    <img @click="openTabletImg(false)" class="table-img" :src="finishImageTablet">
                                    <v-btn outlined @click="openTabletImg(false)" color="var(--app-dark-blue-1) "
                                        class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                                        Изменить
                                    </v-btn>
                                </div>


                            </td>
                            <td class="text-left">
                                <v-btn icon @click="deleteImage">
                                    <v-icon color="var(--app-red-1)">
                                        mdi-delete-outline
                                    </v-icon>
                                </v-btn>

                            </td>
                        </tr>




                    </tbody>
                </template>
            </v-simple-table>
            <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
                Откадрируйте изображения для всех типов устройств


            </v-alert>
            <v-divider></v-divider>



            <v-dialog width="800px" height="auto" persistent v-if="imgSrc" v-model="dialogMobile">
                <v-card width="800px" height="auto" class="rounded-0">
                    <v-card-title class="dialog-title">
                        <span class="title">Кадрирование изображения</span>
                        <v-icon @click="dialogMobile = false;">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-text class="dialog-description">
                        <div class="dialog-subtitle">
                            <div class="dialog-subtitle-title">
                                Отображение на мобильном устройстве
                            </div>
                            <div class="dialog-subtitle-text">
                                Вы можете изменять размер изображения с помощью колесика мыши и двигать его.
                            </div>
                        </div>

                        <div v-if="imgSrc" class="d-flex justify-space-between">
                            <div style="width: 380px;  height: 380px;">
                                <cropper ref="cropperMobail" :src="imgSrc" style="width: 450px;  height: 450px;"
                                    :stencil-props="{
                                        handlers: {},
                                        movable: false,
                                        scalable: true,

                                    }" :stencil-size="{
    width: 164,
    height: 208
}" image-restriction="stencil" @change="onChangeMobile" />
                            </div>


                            <div style="width: 100%;" class="d-flex justify-center" v-if="resultImageMobile">
                                <img width="164px" height="208px" :src="resultImageMobile">
                            </div>

                        </div>


                    </v-card-text>
                    <v-card-actions class="dialog-buttons">
                        <v-btn @click="closeMobileImg()" class="button-accept">
                            Сохранить
                        </v-btn>

                    </v-card-actions>
                </v-card>
            </v-dialog>



            <v-dialog width="800px" height="auto" persistent v-if="imgSrc" v-model="dialogTablet">
                <v-card width="800px" height="auto" class="rounded-0">
                    <v-card-title class="dialog-title">
                        <span class="title">Кадрирование изображения</span>
                        <v-icon @click="dialogTablet = false;">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-text class="dialog-description">
                        <div class="dialog-subtitle">
                            <div class="dialog-subtitle-title">
                                Отображение на планшете
                            </div>
                            <div class="dialog-subtitle-text">
                                Вы можете изменять размер изображения с помощью колесика мыши и двигать его.
                            </div>
                        </div>

                        <div v-if="imgSrc" class="">

                            <div style="width: 100%;   height: 200px;">
                                <cropper ref="cropperTablet" :src="imgSrc" style="width: 100%;   height: 300px;"
                                    :stencil-props="{
                                        handlers: {},
                                        movable: false,
                                        scalable: true,

                                    }" :stencil-size="{
    width: 322,
    height: 170
}" image-restriction="stencil" @change="onChangeTablet" />
                            </div>

                            <div class="dialog-tablet-img" v-if="resultImageTablet">
                                <img width="322px" height="170px" :src="resultImageTablet">
                            </div>

                        </div>


                    </v-card-text>
                    <v-card-actions class="dialog-buttons">
                        <v-btn @click="closeTabletImg()" class="button-accept">
                            Сохранить
                        </v-btn>

                    </v-card-actions>
                </v-card>
            </v-dialog>



        </div>
        <v-alert color="var(--app-red-1)" type="error" v-model="errImagesMain">
            Прикрепите изображение

        </v-alert>

        <div class="container-block-footer-buttons">
            <div>
                <v-btn @click="saveActivity" style="width: auto !important" class="button-accept">
                    Сохранить
                </v-btn>

            </div>

        </div>



    </div>
</template>
<script>

import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
    components: {
        Cropper
    },
    data: () => ({
        activity: {},

        errImages: false,
        errImagesMain: false,
        dialogMobile: false,

        dialogTablet: false,


        newImage: null,
        imgSrc: '',

        resultImageMobile: '',
        resultImageTablet: '',

        finishImageMobile: '',
        finishImageTablet: '',

        smartphoneMainImage: null,
        tabletMainImage: null,

        formData: new FormData(),


    }),


    methods: {


        deleteImage() {
            this.newImage = null
            this.imgSrc = ''
            this.resultImageMobile = ''
            this.resultImageTablet = ''
            this.finishImageMobile = ''
            this.finishImageTablet = ''
            this.smartphoneMainImage = null
            this.tabletMainImage = null


        },

        openMobileImg() {


            this.dialogMobile = true
            setTimeout(() => {
                this.$refs.cropperMobail.refresh()
            }, 500)


            this.errImages = false
        },
        openTabletImg() {


            this.dialogTablet = true
            setTimeout(() => {
                this.$refs.cropperTablet.refresh()
            }, 500)


            this.errImages = false
        },
        closeTabletImg() {

            this.finishImageTablet = this.resultImageTablet
            this.dialogTablet = false
            const { canvas } = this.$refs.cropperTablet.getResult();
            canvas.toBlob(blob => {
                this.formData.append('tabletImage', blob);

            }, 'image/webp', 0.95);
            this.tabletMainImage = true

        },

        closeMobileImg() {

            this.finishImageMobile = this.resultImageMobile
            this.dialogMobile = false

            const { canvas } = this.$refs.cropperMobail.getResult();
            canvas.toBlob(blob => {
                this.formData.append('smartphoneImage', blob);

            }, 'image/webp', 0.95);
            this.smartphoneMainImage = true


        },

        back() {
            if (this.$route.params.key == 'meetings') {
                this.$router.push({ name: 'CouncilActivity', params: { selectedTicker: 1 } })
            }
            else if (this.$route.params.key == 'other') {
                this.$router.push({ name: 'CouncilActivity', params: { selectedTicker: 2 } })
            }
            else if (this.$route.params.key == 'vote') {
                this.$router.push({ name: 'CouncilActivity', params: { selectedTicker: 3 } })
            }


        },


        previewImage() {

            if (this.newImage) {

                this.imgSrc = URL.createObjectURL(this.newImage)
            }
            else {
                this.imgSrc = ''
            }
        },



        defaultSize({ imageSize }) {
            return {
                width: Math.min(imageSize.height, imageSize.width),
                height: Math.min(imageSize.height, imageSize.width),
            };
        },


        onChangeMobile({ canvas }) {
            this.resultImageMobile = canvas.toDataURL()
        },

        onChangeTablet({ canvas }) {
            this.resultImageTablet = canvas.toDataURL()


        },

        getActivity() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/activity', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    key: this.$route.params.key
                }
            })
                .then(res => {
                    this.activity = res.data

                    this.newImage = this.activity.originalImage
                    this.imgSrc = this.activity.originalImage
                    this.smartphoneMainImage = this.activity.smartphoneImage
                    this.tabletMainImage = this.activity.tabletImage
                    this.activity.smartphoneImage ? this.finishImageMobile = this.activity.smartphoneImage : ''
                    this.activity.tabletImage ? this.finishImageTablet = this.activity.tabletImage : ''


                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        saveActivity() {
            if (this.newImage) {
                if (this.smartphoneMainImage && this.tabletMainImage) {
                    this.errImages = false


                    this.formData.append('key', this.$route.params.key)

                    this.formData.append('originalImage', this.newImage || null)



                    this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/activity', this.formData, {
                        headers: {
                            'authorization': this.$store.getters.adminPanelHeaderAuth
                        }
                    })
                        .then(() => {
                            if (this.$route.params.key == 'meetings') {
                                this.$router.push({ name: 'CouncilActivity', params: { selectedTicker: 1 } })
                            }
                            else if (this.$route.params.key == 'other') {
                                this.$router.push({ name: 'CouncilActivity', params: { selectedTicker: 2 } })
                            }
                            else if (this.$route.params.key == 'vote') {
                                this.$router.push({ name: 'CouncilActivity', params: { selectedTicker: 3 } })
                            }

                        })
                        .catch(err => {
                            this.$store.commit('errorSet', true)
                            this.$store.commit('errorTextSet', err)
                        })

                }
                else {
                    this.errImages = true
                }
            }
            else {
                this.errImagesMain = true
            }

        },
    },
    created() {
        this.getActivity()
    },

    watch: {
        newImage() {
            if (this.newImage) {
                this.errImagesMain = false
            }
        }

    }
}
</script>
<style lang="scss" scoped>
.container-main {
    box-sizing: border-box;

    padding: 40px !important;

    .container-main-header-button {
        display: flex;
        align-items: center;
        margin-bottom: 30px;

        span {
            font-size: 28px;
            font-weight: 400;
            margin-left: 16px;
        }
    }

    .container-block {
        width: 50%;
        margin-bottom: 20px;

        .container-block-title {
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 16px;

        }

        .container-block-gallery-button {
            text-decoration: underline;
            color: #1064DD;
            font-size: 18px;
            font-weight: 400;
            cursor: pointer;
            padding-bottom: 20px;
        }

        .table-img {
            // width: 62px;
            height: 38px;
            object-fit: contain;
        }


    }

    .container-block-footer-buttons {
        display: flex;
        justify-content: space-between;
        width: 50%;
        margin-top: 60px;
    }

}

.dialog-tablet-img {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;

    img {
        width: 658;
        height: 192;
    }
}
</style>